import UAParser from "ua-parser-js";

export default class UserAgentUtil {
  static parser = new UAParser();

  static isMobileDevice() {
    try {
      return this.parser.getResult().device.type?.toLowerCase() === "mobile";
    } catch (e) {}
    return false;
  }

  static isTabletDevice() {
    try {
      const isIpad = !!(navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform));
      return isIpad || this.parser.getResult().device.type?.toLowerCase() === "tablet";
    } catch (e) {}
    return false;
  }

  static isIEBrowser() {
    try {
      return this.parser.getBrowser().name?.toLowerCase() === "ie";
    } catch (e) {}
    return false;
  }

  static isChromeBrowser() {
    try {
      return this.parser.getBrowser().name?.toLowerCase() === "chrome";
    } catch (e) {}
    return false;
  }

  static isSafariBrowser() {
    try {
      const browserName = this.parser.getBrowser().name?.toLowerCase();
      return browserName && ["safari", "mobile safari"].includes(browserName);
    } catch (e) {}
    return false;
  }

  static isEdgeBrowser() {
    try {
      return this.parser.getBrowser().name?.toLowerCase() === "edge";
    } catch (e) {}
    return false;
  }

  static isSupportedBrowser() {
    return this.isChromeBrowser() || this.isSafariBrowser() || this.isEdgeBrowser();
  }

  static isAndroid() {
    try {
      return this.parser.getOS().name?.toLowerCase() === "android";
    } catch (e) {}
    return false;
  }

  static isIOS() {
    try {
      return this.parser.getOS().name?.toLowerCase() === "ios";
    } catch (e) {}
    return false;
  }
}
